import { render, staticRenderFns } from "./ComponentResizer.vue?vue&type=template&id=09cad765&scoped=true"
import script from "./ComponentResizer.vue?vue&type=script&lang=ts"
export * from "./ComponentResizer.vue?vue&type=script&lang=ts"
import style0 from "./ComponentResizer.vue?vue&type=style&index=0&id=09cad765&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09cad765",
  null
  
)

export default component.exports